/**
 * Skeleton — muted placeholder block with a 1.4 s shimmer sweep.
 *
 * Variants size the block to common surface shapes: line for text rows,
 * block for short paragraphs / inline tiles, card for full-width panels.
 */

import { cn } from '@/lib/utils';

type SkeletonProps = {
  variant?: 'block' | 'line' | 'card';
  className?: string;
};

const dims = {
  block: 'h-16 w-full rounded-lg',
  line:  'h-3 w-full rounded',
  card:  'h-20 w-full rounded-2xl',
} as const;

export function Skeleton({ variant = 'block', className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'kaiva-shimmer relative overflow-hidden bg-muted/50',
        dims[variant],
        className,
      )}
    />
  );
}
